import { App } from "vue"
import store from "@/store"
import { RolePermission } from "@/permissions/RolePermission"
import { AuthUser } from "@/types/models/user"

const registerPermissions = (app: App) => {
  app.config.globalProperties.hasPermission = (
    permission: RolePermission,
    user?: any
  ) => {
    if (!permission) return false

    // If no user is provided, use currentUser from store
    const userToCheck = user || (store && store.state.currentUser)

    if (!userToCheck) {
      return false
    }

    return userToCheck.role_capabilities?.includes(permission)
  }

  app.config.globalProperties.hasAnyPermissions = (
    permissions: RolePermission[],
    user?: any
  ) => {
    return permissions.some(p => app.config.globalProperties.hasPermission(p, user))
  }
}
declare global {
  // eslint-disable-next-line no-unused-vars
  const hasPermission: (permission: RolePermission, user?: AuthUser) => boolean
  // eslint-disable-next-line no-unused-vars
  const hasAnyPermissions: (permissions: RolePermission[], user?: AuthUser) => boolean
}

export { registerPermissions }
